import { AppDispatch } from '../redux/store';
import { getLiveGuidelineProductTagsByLiveGuidelineProductIdsAction } from '../redux/actions/liveGuidelineProductTagActions';

// Batch size for fetching live guideline product tags.
export const LIVE_GUIDELINE_TAGS_BATCH_SIZE = 50;

export type LiveGuidelineProductTagLike = {
    liveGuidelineProductId: number;
    tag?: { name?: string };
    name?: string;
};

export const fetchLiveGuidelineTagsInBatches = async (
    dispatch: AppDispatch,
    liveGuidelineProductIds: number[],
): Promise<LiveGuidelineProductTagLike[]> => {
    const allTags: LiveGuidelineProductTagLike[] = [];

    for (let i = 0; i < liveGuidelineProductIds.length; i += LIVE_GUIDELINE_TAGS_BATCH_SIZE) {
        const batch = liveGuidelineProductIds.slice(i, i + LIVE_GUIDELINE_TAGS_BATCH_SIZE);
        if (!batch.length) {
            continue;
        }
        const { payload } = (await dispatch(
            getLiveGuidelineProductTagsByLiveGuidelineProductIdsAction(batch),
        )) as { payload?: LiveGuidelineProductTagLike[] };

        if (Array.isArray(payload)) {
            allTags.push(...payload);
        }
    }

    return allTags;
};
